import LocalStorage from '../LocalStorage/LocalStorage';
import { useDispatch } from 'react-redux';
import { useNavigate } from "react-router-dom";
import {
  setAdmin,
  setFullManufacturersListData,
  setUserData,
  setDataSets,
  setDashboardAccess,
  setNotifications,
  setItemScoreAccess
} from '../../reducers/UserReducer/UserActions';
import { mfrPlatformIdToDmId } from '../../config/constants';
import userApi from '../../api/userApi';
import { toast } from 'react-toastify';
import notificationsApi from '../../api/notificationsApi';
import initPendo from '../initPendo/initPendo';
import useManufacturerData from "../useManufacturerData/useManufacturerData";

const useLogin = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { setSelectedManufacturers } = useManufacturerData();

  const login = (data) => {
    const {manufacturer, manufacturers, ...userData} = data;
    LocalStorage.resetKey.set(data.user.reset_password_token);
    LocalStorage.userData.set(userData);
    LocalStorage.authKey.set(data.user.token);
    if(userData?.user?.dashboard === true) {
      localStorage.setItem('branding', 'BEP');
    } else if (userData?.user?.chainData === true || userData?.user?.emergingData === true || userData?.user?.itemScore === true) {
      localStorage.setItem('branding', 'ARROWSTREAM');
    } else {
      toast.error('You do not have access to this portal.');
    }
    if(manufacturers && data.user.internalAdmin === true) {
      dispatch(setFullManufacturersListData(manufacturers));
    }
    if(manufacturers && data.user.internalAdmin !== true) {
      LocalStorage.userManufacturerData.set(manufacturers);
      setSelectedManufacturers(manufacturers);
    }
    if (manufacturer) {
      if (mfrPlatformIdToDmId[manufacturer.platform_id]) {
        const dmIdData = {
          ...manufacturer,
          data_manager_id: mfrPlatformIdToDmId[manufacturer.platform_id].dmId
        }
        LocalStorage.manufacturerData.set(dmIdData);
      } else {
        LocalStorage.manufacturerData.set(manufacturer);
      }
    }
    if (data.user.internalAdmin === true) {
      dispatch(setAdmin(true));
    }
    dispatch(setDataSets(data.user.chainData, data.user.emergingData));
    dispatch(setDashboardAccess(data.user.dashboard));
    dispatch(setItemScoreAccess(data.user.itemScore));
    dispatch(setUserData(data));
    getNotifications();
    initPendo(data.user, manufacturer);
  };

  const manufacturerLogin = (data) => {
    if (mfrPlatformIdToDmId[data.platform_id]) {
      const dmIdData = {
        ...data,
        data_manager_id: mfrPlatformIdToDmId[data.platform_id].dmId
      }
      LocalStorage.manufacturerData.set(dmIdData);
    } else {
      LocalStorage.manufacturerData.set(data);
    }
    const userData = LocalStorage.userData.get();
    if (userData && userData.user) {
      initPendo(userData.user, data);
    }
  };

  const adminUserLogin = (userId) => {
    const params = {
      "id" : userId
    };
    userApi.adminUserLogin.post(params).then((data) => {
      login(data.data);
      localStorage.removeItem('allManufacturerData');
      dispatch(setAdmin(false));
      if (localStorage.getItem('redirect')) {
        navigate(localStorage.getItem('redirect'));
        localStorage.removeItem('redirect');
      } else {
        navigate('/dashboard');
      }
    });
  }

  const getNotifications = () => {
    notificationsApi.all.get().then((response) => {
      dispatch(setNotifications(response.data));
    });
  }

  const authenticateTableau = (data) => {
    LocalStorage.tableauTicket.set(data);
  };

  return {
    login,
    authenticateTableau,
    manufacturerLogin,
    adminUserLogin
  };
};

export default useLogin;
